export default {
  openapp: "Open APP",
  noStore: "Stores don't exist",
  rating: "Rating:",
  Categories: "Categories:",
  PreparationTime: "Preparation time:",
  DeliveryFee: "Delivery Fee",
  FreeDelivery:"Free Delivery",
  deducedeliveryfee :'Deduce delivery fee',
  noScore: 'No reviews',
  discountTitle: 'Discount',
  fullReductionTitle: 'Full Reduce Offer',
  storeFirstTitle: 'First Order',
  promotionTitle: 'Promotion',
  StoreAnnouncement:'Store Announcement',
  Businesshours: 'Business hours',
  DeliveryScope:'Delivery Scope',
  PaymentMethod: 'Payment Method',
  goAppTip: 'More discount at WOWNOW APP',
  CashonDelivery: 'Cash on Delivery',
  PayOnline: 'Pay Online',
  availablecoupons: 'Store coupon',
  Get: 'Get',
  refresh: 'refresh',
  MONDAY: 'Mon.',
  TUESDAY: 'Tues.',
  WEDNESDAY: 'Wed.',
  THURSDAY: 'Thur.',
  FRIDAY: 'Fri.',
  SATURDAY: 'Sat.',
  SUNDAY: 'Sun.',
  MerchantService: 'Merchant Service'
}